const constants = {
  primary: {
    main: '#EC6825',
    light: '#FF9668',
    dark: '#CD5600'
  },
  secondary: {
    main: '#29519D',
    light: '#607dcf',
    dark: '#002a6e'
  },
  tertiary: {
    main: '#eb3343',
    light: '#ff6c6e',
    dark: '#b1001c'
  },
  grey: {
    main: '#171F46',
    light: '#8F8F8F',
    lighter: '#F4F4F4'
  },
  white: {
    main: '#FFF'
  },
  breakpoints: {
    lg: 1280,
    md: 960,
    sm: 600,
    xl: 1920,
    xs: 0
  }
}

export default constants
